import { apiClient } from '~/shared/api/data-ingestion-api'
import { generateNewDocumentId } from './generate-new-document-id'
import { getExistingDocumentPageRanges } from './get-existing-document-page-ranges'
import { type DocumentPageRange } from './types'

export function unsplitDocumentPageRanges({
  documents,
  currentDocumentPageRanges,
  documentId,
  unsplitIndex,
}: {
  documents: apiClient.Document[]
  currentDocumentPageRanges: DocumentPageRange[]
  documentId: string
  unsplitIndex: number
}) {
  const idx = currentDocumentPageRanges.findIndex((r) => r.documentId === documentId)
  if (idx === -1) return []

  const current = currentDocumentPageRanges[idx]
  const next = currentDocumentPageRanges
    .filter((r) => r.pageRange.startPage > unsplitIndex)
    .sort((a, b) => a.pageRange.startPage - b.pageRange.startPage)?.[0]
  if (!next) return []

  const merged = {
    documentId: generateNewDocumentId(),
    pageRange: {
      startPage: current.pageRange.startPage,
      endPage: next.pageRange.endPage,
    },
    confidenceScore: 1,
  }

  return [
    ...currentDocumentPageRanges.slice(0, idx),
    ...getExistingDocumentPageRanges(documents, [merged]),
    ...currentDocumentPageRanges.slice(idx + 2),
  ]
}
